import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 列表
export const loanListget = (data: any) =>
  request.post('/erp/web/youka/retail_loan/erpSelectPageList', data, jsonHeaderConfig)
export const loanBpmListget = (data: any) =>
  request.post('/erp/web/youka/retail_loan/bpmSelectPageList', data, jsonHeaderConfig)
// 导出
export const erpExport = '/erp/web/youka/retail_loan/erpExport'
export const bpmExport = '/erp/web/youka/retail_loan/bpmExport'
// 详情
export const loanDetailERPget = (data: any) =>
  request.post('/erp/web/youka/retail_loan/erp/confirmLoanInfo', data)
export const loanDetailERPgetDetail = (data: any) =>
  request.post('/erp/web/youka/retail_loan/erp/erpDetailInfo', data)
// 详情
export const loanDetailBPMget = (data: any) =>
  request.post('/erp/web/youka/retail_loan/bpm/confirmLoanInfo', data)
export const loanDetailBPMgetDetail = (data: any) =>
  request.post('/erp/web/youka/retail_loan/bpm/bpmDetailInfo', data)
// 银行卡
export const bankListget = (data: any) =>
  request.post('/erp/youka/pay-operate/getCardList', data, jsonHeaderConfig)
// 确认
export const confirmLoanPost = (data: any) =>
  request.post('/erp/web/youka/retail_loan/confirmLoan', data, jsonHeaderConfig)
// 刷新债转余额
export const refreshWallet = (data: any) =>
  request.post('/erp/youka/retail-refinancing-wallet/refreshWallet', data)
// 放款计划
export const loanPlanListGet = (data: any) =>
  request.post('/erp/web/youka/retail_loan/getRepaymentSchedule', data, jsonHeaderConfig)

// 放款明细
export const loadRecordListGet = (data: any) =>
  request.post('/erp/web/youka/retail_loan/loanInfoPageList', data, jsonHeaderConfig)
// count
export const loanStateCountGet = (data?: any) =>
  request.post('/erp/web/youka/retail_loan/erpSelectLoanStatusCount', data)
export const loanBpmStateCountGet = (data?: any) =>
  request.post('/erp/web/youka/retail_loan/bpmSelectLoanStatusCount', data)
// total
export const selectLoanMoneyCount = (data?: any) =>
  request.post('/erp/web/youka/retail_loan/erpSelectLoanMoneyCount', data, jsonHeaderConfig)
export const selectBpmLoanMoneyCount = (data?: any) =>
  request.post('/erp/web/youka/retail_loan/bpmSelectLoanMoneyCount', data, jsonHeaderConfig)
// 放款合同
export const contractLoanListGet = (data?: any) =>
  request.post('/erp/retailContractManage/queryByIntoId', data, jsonHeaderConfig)
// 放款合同2
export const contractLoanListGet2 = (data?: any) =>
  request.post('/erp/retailContractManage/queryByBusinessForm', data, jsonHeaderConfig)
// 查詢账户下拉
export const selectConfirmedPayAccount = (data?: any) =>
  request.post('/erp/youka/retail-organ-pay-relevance/withdrawal/selectConfirmedPayAccount', data)
// 放款审批详情
export const getApproveInfo = (data: any) =>
  request.post('/erp/web/youka/retail_loan/getApproveInfo', data)
export const confirmLoanPreCheck = (data: any) =>
  request.post('/erp/web/youka/retail_loan/confirmLoanPreCheck', data)
export const updateBankAccount = (data: any) =>
  request.post('/erp/web/youka/retail_loan/updateBankAccount', data, jsonHeaderConfig)
export const offlineLoanAccount = (data: any) =>
  request.post('/erp/web/youka/retail_loan/offlineLoanAccount', data)
export const offlineLoan = (data: any) =>
  request.post('/erp/web/youka/retail_loan/offlineLoan', data, jsonHeaderConfig)

export const getApproveCount = () =>
  request.post('/erp/web/youka/retail_loan/erp/approveStatusCount', null, jsonHeaderConfig)

export const getBpmApproveCount = () =>
  request.post('/erp/web/youka/retail_loan/bpm/approveStatusCount', null, jsonHeaderConfig)
// 获取系统参数
export const getSysParamByCode = (params: Recordable) =>
  request.get('/erp/youka/sys-param/getSysParamByCode', params, jsonHeaderConfig)
